'use client'

import { Charts } from './Charts';
import BasicBenefitsChartsDataProvider from './contexts/BasicBenefitsChartContext';

const BasicBenefitsWrapper = () => {
    return (
        <BasicBenefitsChartsDataProvider>
            <Charts />
        </BasicBenefitsChartsDataProvider>
    );
};

export default BasicBenefitsWrapper;
